import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http'
import * as Auth from '@aws-amplify/auth'
import { from, Observable, switchMap } from 'rxjs'

export const jwtInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (URL.canParse(request.url)) {
    const url = URL.parse(request.url)
    if (url?.host !== location.host) {
      return next(request)
    }
  }
  return from(Auth.fetchAuthSession()).pipe(
    switchMap((session) => {
      const sessionToken = session.tokens?.accessToken?.toString() ?? ''
      const clonedRequest = request.clone({
        withCredentials: false,
        setHeaders: {
          Authorization: `Bearer ${sessionToken}`,
        },
      })
      return next(clonedRequest)
    })
  )
}
